import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsDisabled} from "../../data";

export const Root = styled.div<IsDisabled>`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    width: 100%;
    
    ${(props) => props.$isDisabled && css`
        pointer-events: none;
    `}

    ${device.less1180} {
        gap: 5px 15px;
    }

    ${device.less768} {
        gap: 10px;
    }
`;

export const Item = styled.div`

`;
